import { ModelConsultDtoFilterInput } from 'app/graphql/API'

/**
 * Builds a server-side ModelConsultDtoFilterInput that matches consults whose
 * `tags` list contains ANY of the supplied tags (OR semantics) for scale-correct
 * tag search on the byOwner GSI query (ACA-123).
 *
 * DynamoDB applies this filter within the owner's partition, so a tag search
 * covers ALL of a clinician's consults rather than only the pages already
 * loaded by the History infinite-scroll (which is the limit of the client-side
 * filter from ACA-122).
 *
 * Returns undefined when no usable tags are supplied, so the caller omits the
 * filter argument entirely (unfiltered listing).
 *
 * @param tags - Selected tags to match (any subset of a consult's tags).
 */
export function buildConsultTagFilter(
    tags: string[]
): ModelConsultDtoFilterInput | undefined {
    const cleaned = Array.from(
        new Set(
            (tags ?? [])
                .filter((t): t is string => typeof t === 'string')
                .map((t) => t.trim())
                .filter((t) => t.length > 0)
        )
    )

    if (cleaned.length === 0) {
        return undefined
    }

    if (cleaned.length === 1) {
        return { tags: { contains: cleaned[0] } }
    }

    return { or: cleaned.map((t) => ({ tags: { contains: t } })) }
}
